import React from 'react';
import styles from './WelcomeSection.module.scss';
import Button from '@mui/material/Button';
import {AttentionSeeker, Bounce, Hinge, JackInTheBox, Roll, Rotate, Slide} from "react-awesome-reveal";
import Section from './Section';
import {stHOME} from "./NavBar";

const Balance = () => (<img className={styles.eqqIcon} src={'/balance.svg'}/>);
const Quill = () => (<img className={styles.eqqIcon} src={'/quill.svg'}/>);

const WelcomeSection: React.FC = () => {
    return (
        <Section id={stHOME}>
                <>
                    <h1>Welcome to EquiQuill</h1>
                    <h2>
                        <JackInTheBox>
                            <div><Balance/><span className={styles.pun}>Equi</span>librium through the <span className={styles.pun}>Quill</span><Quill/></div>
                        </JackInTheBox>
                        Your daily companion for journaling</h2>
                    <p>An exciting and innovative application that fosters daily journaling habits through a fun and
                        interactive journaling app.</p>
                    <br/>
                    <br/>
                    <AttentionSeeker delay={2000} effect={"rubberBand"}>
                        <Button className={styles.launchButton}
                            variant="contained" color="primary" href={"https://app.equiquill.com"}>&lt;/&gt; Launch Web Version</Button>
                    </AttentionSeeker>
                    <p>OR</p>
                    <div className={styles.appStoreButtons}>
                        <AttentionSeeker delay={3000} effect={"rubberBand"}>
                        <a href='https://play.google.com/store/apps/details?id=com.equiscrib.equiscribapp&hl=en_CA&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
                            alt='Get it on Google Play'
                            height={70}
                            src='/google-play-badge.png'/></a>
                        </AttentionSeeker>
                        <AttentionSeeker delay={4000} effect={"rubberBand"}>
                        <a href="https://apps.apple.com/us/app/equiquill/id6480310982?itscg=30200&itsct=apps_box_badge&mttnsubad=6480310982">
                            <img src="/app-store-badge.svg"
                                height={48}
                                alt="Download on the App Store"/>
                        </a>
                        </AttentionSeeker>

                    </div>
                </>
        </Section>
    );
};

export default WelcomeSection;